import {dayMonthYearAtTimeWithSeconds} from "./dates";

export default class Objects {

  static getValueByCustomField(field, item, column) {
    const route = field.split('.');
    let lastValue = item;
    console.log(route)
    route.forEach(field => {

      if (Array.isArray(lastValue)) {
        lastValue = lastValue.map(x => x[[field]]);
      } else {
        lastValue = !lastValue ? '' : (!lastValue[field] ? '' : lastValue[field])
      }
    });

    if (column && column.isDate && lastValue) {
      return dayMonthYearAtTimeWithSeconds(lastValue);
    }

    return Array.isArray(lastValue) ? lastValue.join(';') : lastValue;
  }

  static nonEmptyOrBlank(text) {
    return !Objects.isEmptyOrBlank(text);
  }

  static isEmptyOrBlank(text) {
    if (Objects.isNullOrUndefined(text)) {
      return true;
    }

    return text.length <= 0;

  }

  static isNullOrUndefined(text) {
    return text === null || text === undefined || text === 'undefined';
  }

  static nonNull(object) {
    return !Objects.isNullOrUndefined(object);
  }
}





// WEBPACK FOOTER //
// ./src/utils/Objects.js